import { IFieldTabArrayState } from './field-tab-array.reducer';

export function selectCurrent(state: IFieldTabArrayState) {
  return state.data?.filter((content) => !content?.isFormer);
}

export function selectFormer(state: IFieldTabArrayState) {
  return state.data?.filter((content) => content?.isFormer);
}
